//      
import React from "react";

                  
              
 

const Zoom = (props          ) => {
	const {img} = props;

	return <img src={img} alt={""} style={{height: 100 + "%", width: 100 + "%", objectFit: "contain"}}/>;
}
;

export default Zoom;
